<template>
  <div>
    <div class="background"></div>
    <div class="contact">
      <baidu-map class="map" :center="markerPoint" :zoom="19">
        <bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
          <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen"
                          style="width:400px;font-size:16px">
            湖北卡玛云智能有限公司<br><br>
            地址：湖北省十堰市茅箭区武当路街道重庆路1号<br><br>
            联系电话：0719-8499880
          </bm-info-window>
        </bm-marker>
      </baidu-map>
      <div class="message">
        <div style="position:absolute;top:60px;margin:0 auto;padding:0 0 0 60px">
          <span class="msgTitle">联系电话：</span>&nbsp;<span>0719-8499880</span><br/>
          <span class="msgTitle">邮箱地址：</span><br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="msgTitle">项目部：</span><span>&nbsp;kama_777@163.com</span><br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="msgTitle">市场部：</span><span>&nbsp;kama_888@163.com</span><br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="msgTitle">技术部：</span><span>&nbsp;kama_999@163.com</span><br/>
          <span class="msgTitle">详细地址：</span>&nbsp;<span>湖北省十堰市茅箭区武当路街道重庆路1号老三环院内</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        data() {
            return {
                markerPoint: {lng: 110.817067, lat: 32.599403},
                show: false,
                map: {}
            };
        },
        methods: {
            infoWindowClose() {
                this.show = false
            },
            infoWindowOpen() {
                this.show = true
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
  .background {
    position: fixed;
    width: 100%;
    min-width: 1366px;
    height: 100%;
    background-image: url("../../../static/img/cheJian.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    opacity: 0.3;

    z-index: -1; /*-1 可以当背景*/
    filter: blur(8px);
  }

  .contact {
    width: 1366px;
    height: 685px;
    margin: auto;

  }

  .map {
    width: 650px;
    height: 700px;
    border: 5px solid #fff;
    box-shadow: -5px 0px 25px #000;

    display: inline-block;
    margin-top: 35px;
    margin-left: 10px;
  }

  .msgTitle{
    font-weight: bold;
  }

  .message{
    width: 550px;
    height: 550px;
    font-size: 22px;
    line-height:60px;
    display: inline-block;
    background-image: linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0));
    border-radius: 15px;

    position: relative;
    margin: 120px 50px 0 0;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contact/contactUs.vue